export const responseSnowflakeStorages = {
  data: {
    attributes: {
      path: '/ebs/ftpd/test-1641468440915-000001'
    },
    id: 1014
  }
};

